import axios from 'axios';
import store from '@/store';
import { isGivingApiUrl } from '@/utils/interceptors/giving-pin-session';
import { MY_GIVING_PATH, isGivingLoginUnverified, isGivingRecordPath } from '@/utils/giving-login';

/**
 * Giving per login: giving-api answers 403 GIVING_LOGIN_UNVERIFIED on the routes that
 * read the member's giving records when this login has not confirmed the member's
 * personal id (@/utils/giving-login). The interceptor records that in the store, and
 * a member on a page that only shows records (tithe history, building fund, pledges)
 * goes to the MyGiving landing page, which shows the personal-id check.
 *
 * Elsewhere (Manage, the notifications list) the page shows what it can and the
 * error goes on to the caller, which knows not to toast it.
 */

let responseInterceptorId = null;

export function removeGivingLoginInterceptor() {
  if (responseInterceptorId !== null) axios.interceptors.response.eject(responseInterceptorId);
  responseInterceptorId = null;
}

/**
 * @param {{ router?: { currentRoute: { value: { path: string } }, replace: Function } }} options
 */
export function initGivingLoginInterceptor({ router } = {}) {
  removeGivingLoginInterceptor();

  responseInterceptorId = axios.interceptors.response.use(
    response => response,
    error => {
      try {
        if (
          isGivingLoginUnverified(error) &&
          isGivingApiUrl(error.config?.url, error.config?.baseURL)
        ) {
          store.commit('myGiving/markLoginUnverified');
          const current = router?.currentRoute?.value;
          if (current && isGivingRecordPath(current.path)) {
            router.replace(MY_GIVING_PATH).catch(() => {});
          }
        }
      } catch (err) {
        console.error('[GivingLogin] response interceptor error:', err?.message);
      }
      return Promise.reject(error);
    },
  );
}
